module.exports = __webpack_public_path__ + "img/wallet.ee550a11.svg";